import React from 'react';
import { connect } from 'react-redux';

import { SpinnerOverlay, SpinnerCircle } from './Styles/Spinner';

export const SpinnerWithOverlay = ({ showSpinner, width, height, overlayWidth, overlayHeight, ...props }) => {
	return (
		<SpinnerOverlay
			style={{ display: `${showSpinner ? 'block' : 'none'}` }}
			width={overlayWidth}
			height={overlayHeight}
			{...props}
		>
			<SpinnerCircle
				width={width}
				height={height}
				{...props}
			/>
		</SpinnerOverlay>
	);
};

export const Spinner = ({ showSpinner, width, height, ...props }) => {
	return (
		<SpinnerCircle
			style={{ display: `${showSpinner ? 'block' : 'none'}` }}
			width={width}
			height={height}
			{...props}
		/>
	);
};

const GlobalSpinner = (props) => {
	return <SpinnerWithOverlay showSpinner={props.spinner > 0 ? true : false} />;
};

const mapStatesToProps = (state) => {
	return {
		spinner: state.spinner.spinner,
	};
};

const mapFunctionsToProps = {};

export default connect(mapStatesToProps, mapFunctionsToProps)(GlobalSpinner);
